// extracted by mini-css-extract-plugin
export default {"scheduleHeader":"Schedule_scheduleHeader__CKBi3"};